"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWizard = exports.WIZARD_VIEW_TYPE = void 0;
const react_1 = require("react");
const core_1 = require("@veeam/core");
const PageWizardViewController_1 = require("../ribs/view/PageWizardViewController");
const WizardViewController_1 = require("../ribs/view/WizardViewController");
const ribs_1 = require("../ribs");
const wizard_1 = require("../ribs/wizard");
const WizardRootRouter_1 = require("../ribs/WizardRootRouter");
const StepBuilder_1 = require("../types/StepBuilder");
var WIZARD_VIEW_TYPE;
(function (WIZARD_VIEW_TYPE) {
    WIZARD_VIEW_TYPE[WIZARD_VIEW_TYPE["normal"] = 0] = "normal";
    WIZARD_VIEW_TYPE[WIZARD_VIEW_TYPE["page"] = 1] = "page";
})(WIZARD_VIEW_TYPE = exports.WIZARD_VIEW_TYPE || (exports.WIZARD_VIEW_TYPE = {}));
function isNormalWizardConfig(config) {
    if (!config.hasOwnProperty('view')) {
        return true;
    }
    return config.view === WIZARD_VIEW_TYPE.normal;
}
function isPageWizardConfig(config) {
    return config.view === WIZARD_VIEW_TYPE.page;
}
function createWizardViewController(config) {
    if (isNormalWizardConfig(config)) {
        return new WizardViewController_1.WizardViewController(config);
    }
    if (isPageWizardConfig(config)) {
        return new PageWizardViewController_1.PageWizardViewController(config);
    }
    throw new Error('useWizard error: bad config');
}
function isStepBuildable(step) {
    return typeof step.build === 'function';
}
class FeatureWizardRouter extends WizardRootRouter_1.WizardRootRouter {
}
class EmptyStepInteractor extends ribs_1.StepInteractor {
}
class EmptyWizardInteractor extends ribs_1.WizardInteractor {
}
class FeatureWizardBuilder {
    constructor(interactor, wizardBuilder) {
        this.interactor = interactor;
        this.wizardBuilder = wizardBuilder;
    }
    build() {
        const router = new FeatureWizardRouter(this.interactor, this.wizardBuilder, new core_1.RootViewController());
        return { router };
    }
}
const useWizard = (configure) => {
    var _a, _b;
    const moduleRef = (0, react_1.useRef)(null);
    const { getErrorListener } = (0, core_1.useAppContext)();
    const catchError = (0, react_1.useCallback)((e) => {
        try {
            getErrorListener().onCatchError(e);
        }
        catch (_a) {
            console.error(e);
        }
    }, [getErrorListener]);
    if (!moduleRef.current) {
        const { steps, interactor = new EmptyWizardInteractor(), config, listener } = configure();
        const wizardBuilder = new wizard_1.WizardBuilder({
            listener: Object.assign(Object.assign({}, listener), { willDone: interactor.willDone.bind(interactor) }),
            viewController: createWizardViewController(config),
            config: {
                isNextStepAvailable: (_a = config.isNextStepAvailable) !== null && _a !== void 0 ? _a : true,
                onStepChange: (prevStepId, nextStepId) => {
                    interactor.didStepChange(prevStepId, nextStepId);
                },
                prioritizeUseActionsState: (_b = config.prioritizeUseActionsState) !== null && _b !== void 0 ? _b : false
            },
            steps: steps.filter(Boolean).map((step) => {
                if (isStepBuildable(step)) {
                    return step;
                }
                let bodyViewController = new core_1.RootViewController();
                if (typeof step.render === 'function') {
                    bodyViewController = new core_1.ReactViewController({}, step.render.bind(step));
                }
                if (step.viewController) {
                    bodyViewController = step.viewController;
                }
                bodyViewController.texts = step.texts;
                return new StepBuilder_1.StepBuilder(step.interactor || new EmptyStepInteractor(), bodyViewController, step, step.child);
            })
        });
        const builder = new FeatureWizardBuilder(interactor, wizardBuilder);
        try {
            const module = builder.build();
            module.router.load().catch((e) => console.error(`Router load error: ${e}`));
            moduleRef.current = module;
        }
        catch (e) {
            catchError(e);
        }
    }
    (0, react_1.useEffect)(() => {
        return () => {
            if (moduleRef.current) {
                try {
                    moduleRef.current.router.unload();
                    moduleRef.current = null;
                }
                catch (e) {
                    catchError(e);
                }
            }
        };
    }, [catchError]);
    return {
        component: moduleRef.current
            ? moduleRef.current.router.viewController.render()
            : null
    };
};
exports.useWizard = useWizard;
//# sourceMappingURL=useWizard.js.map